import { QueryClient } from '@tanstack/react-query';

/**
 * Instância global do QueryClient do TanStack Query.
 *
 * Configurações padrão:
 * - `staleTime`: 0 — dados sempre considerados stale (refetch em cada montagem)
 * - `gcTime`: 5 minutos — cache mantido em memória por 5min após inatividade
 * - `retry`: 1 — tenta novamente 1x em caso de erro (exceto 4xx)
 * - `refetchOnWindowFocus`: false — não refetch ao voltar o foco (admin panel)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 5 * 60 * 1000,
      retry: (failureCount, error) => {
        // Não tenta novamente em erros de cliente (4xx)
        if (error instanceof Error && 'status' in error) {
          const status = (error as unknown as { status: number }).status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
